module.exports = __webpack_public_path__ + "img/pos_mode_logo.cc68ac68.svg";